module.exports = __webpack_public_path__ + "static/img/process-quality-2.b517c718.png";